import React from 'react';

import LookupStatusBadge from '~components/LookupStatusBadge';

import { CarePlan } from '~clients/models';

import { CARE_PLAN_STATUS_BADGE, deriveCarePlanStatus } from '~clients/config/carePlanEnums';
import { CARE_PLAN_TYPES } from '~clients/config/carePlanTypes';

import { formatDateString } from '~libs/dayjs';

interface ComponentProps {
  plan: CarePlan;
  packageName?: string;
  isSelected: boolean;
  onSelect: (planId: string) => void;
}

/**
 * One plan row in the sidebar plan list. The plan "title" is derived from the
 * plan-type config — care plans have no stored title column. Status is likewise
 * derived (no stored status column).
 */
const CarePlanListItem: React.FC<ComponentProps> = ({ plan, packageName, isSelected, onSelect }) => (
  <li className={`plan-list-item${isSelected ? ' selected' : ''}`}>
    <button
      type="button"
      data-cy={`care-plan-list-item-${plan.id}`}
      aria-current={isSelected || undefined}
      onClick={() => onSelect(plan.id)}
    >
      <div className="care-plan-list-item-heading">
        <span>{CARE_PLAN_TYPES[plan.plan_type].label}</span>
        <LookupStatusBadge
          status={CARE_PLAN_STATUS_BADGE[deriveCarePlanStatus(plan)]}
          dataCy={`care-plan-status-${plan.id}`}
        />
      </div>
      <div className="text-muted small" data-cy={`care-plan-package-${plan.id}`}>
        {packageName ?? '—'}
      </div>
      {plan.start_date && <div className="text-muted small">Effective from {formatDateString(plan.start_date)}</div>}
    </button>
  </li>
);

export default CarePlanListItem;
